import React from "react";

import { css } from "@emotion/css";
import { CellContext } from "@tanstack/react-table";

import { useStyles } from "@/hooks/useStyles.ts";
import { NurseInclusionPatient } from "@/models/NurseInclusionPatientModel.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export type EmailColumnProps = CellContext<NurseInclusionPatient, string>;

export const EmailColumn: React.FC<EmailColumnProps> = ({ getValue }) => {
  const styles = useStyles(makeStyles);

  return (
    <Typography className={styles.container} variant="body">
      {getValue()}
    </Typography>
  );
};

const makeStyles = () => ({
  container: css({}),
});
